(function() {
    function NewProduct () {
        const sectionId = $('.as-product-section').attr('id');
        this.tfxProductSizes = tfxProductSizes || {};
        this.skuValid = {};
        this.skuQuickLock = false;
        this.options = {
            option1: null,
            option2: null,
            option3: null
        };
        this.product = window.tfxProduct || {};
        this.asIdToHandle = window.asIdToHandle || [];
        // this.sizeData = window.asSizeChart || {};
        this.sizeData = this.filterWeightHeight(window.asSizeChart) || {};
        this.sizeTableData = {};
        this.bodyWeightHeight = this.returnWeightHeight(window.asSizeChart) || {};
        this.selectors = {
            originalPrice: '.asProduct-price .asProduct-price_sale',
            comparePrice: '.asProduct-price .asProduct-price_compare',
            klarnaPrice: '.Product-wrapper .akm-money',
            countPrice: '.asProduct-count .asProduct-count-price',
            ProductImageItems: `#${sectionId} .ProductImage-items`,
            ProductImageNavItems: `#${sectionId} .ProductImageNav-items`,
            ProductForm: `#${sectionId} .asProductForm`,
            addToCart: `#${sectionId} .asProduct-btn`,
            addToCartText: `#${sectionId} .asProduct-btn span`,
            SelectId: `#${sectionId} #product-select-${sectionId}`,
            ProductTab: `#${sectionId} .as-product-tab`,
            ProductDescribe: `#${sectionId} .product-describe`,
            commonPopup: '.as-product-common-content',
            commonPopupMask: '.as-product-common-mask',
            commonPopupAll: '.as-product-common-mask,.as-product-common-content',
        };
        this.sizeChartHtml = window.asSizeHtml;
        this.klarnaHtml = window.asKlarnaHtml;
        // 韩语/西班牙  XL=》특대/SG
        this.language_size = {
            특대: 'XL',
            SG: 'XL',
        };
        this.language_local = Shopify.locale;
        this.languages = ['ko', 'es'];
        this.sizeToUp = ['us', 'uk', 'eu'],
        this.sizeInitialToUp = ['bust', 'waist', 'hips', 'length', 'sleeve', 'neck', 'shoulder', 'inseam', 'thigh', 'chest', 'legOpening'],
        this.formatSizeData();
        this.init();
    }
    NewProduct.prototype = _.assignIn({}, NewProduct.prototype, {
        init: function () {
            // this.windowResize();

            if ($(window).width() > 766) {
                this.createSwiper();
            }
            this.initData();
            this.initEvent();
            this.initComponent();
        },
        initEvent: function () {
            this.swatchSelectChange();
            this.productAddToCart();
            this.swatchHover();
            this.scrollDetail();
        },
        initData: function () {
            this._initSkuRadio();
            this._initOptions();
        },
        initComponent: function () {
            this._productTabs();
            this._productDescribe();
            this._btnStickyBottom();
            this._productQuickShipPolicy();
            this.sizeAddNumber();
            // this.sizeChart();
            this.initPopupShow();
            this.initPlayVideo();
            this.initThirdApp();
            this.initJudgeMe();
        },
        debounce: function (fn, delay) {
            var timer = null;
            return function () {
                if (timer) clearTimeout(timer);
                var _this = this;
                var _arguments = arguments;
                timer = setTimeout(function () {
                fn.apply(_this, _arguments);
                }, delay);
            }
        },
        // A对象包含B对象
        _AhasBObj: function (A, B) {
            return Object.keys(B).every((key) => A[key] == B[key]);
        },
        filterWeightHeight: function (asSizeChart) {
            const _asSizeChart = JSON.parse(JSON.stringify(asSizeChart || '{}'));
            if (_asSizeChart.bodyMeasurementListCM && _asSizeChart.bodyMeasurementListCM.length > 0) {
                _asSizeChart.bodyMeasurementListCM = _asSizeChart.bodyMeasurementListCM.map((item) => {
                    item.suggestHeight = "";
                    item.suggestWeight = "";
                    return item;
                });
                _asSizeChart.bodyMeasurementListIN = _asSizeChart.bodyMeasurementListIN.map((item) => {
                    item.suggestHeight = "";
                    item.suggestWeight = "";
                    return item;
                });
            }
            return _asSizeChart;
        },
        returnWeightHeight: function (asSizeChart) {
            const _asSizeChart = JSON.parse(JSON.stringify(asSizeChart || '{}'));
            if (
                _asSizeChart.bodyMeasurementListCM
                && _asSizeChart.bodyMeasurementListCM.length > 0
                && _asSizeChart.bodyMeasurementListCM.some((s) => (s.suggestHeight || s.suggestWeight))
            ) {
                _asSizeChart.bodyMeasurementListCM = _asSizeChart.bodyMeasurementListCM.map((item) => {
                    const _item = {};
                    _item.suggestHeight = item.suggestHeight;
                    _item.suggestWeight = item.suggestWeight;
                    _item.size = item.size;
                    return _item;
                });
                _asSizeChart.bodyMeasurementListIN = _asSizeChart.bodyMeasurementListIN.map((item) => {
                    const _item = {};
                    _item.suggestHeight = item.suggestHeight;
                    _item.suggestWeight = item.suggestWeight;
                    _item.size = item.size;
                    return _item;
                });
                return _asSizeChart;
            } else {
                return [];
            }
        },
        createSwiper: function () {
            $(this.selectors.ProductImageItems).slick({
                fade: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                asNavFor: this.selectors.ProductImageNavItems,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            centerMode: true,
                            centerPadding: '8% 0px 0px',
                            arrows: false,
                            fade: false,
                        }
                    }
                ]
            });
            $(this.selectors.ProductImageNavItems).slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                verticalSwiping: true,
                vertical: true,
                focusOnSelect: true,
                asNavFor: this.selectors.ProductImageItems,
            });
            $(this.selectors.ProductImageItems).on('afterChange', function (s, c) {
                const cp = $(this).siblings('.ProductImage-pagination').find('.pp-current');
                cp.text(c.currentSlide + 1);
            });
        },
        windowResize: function () {
            const $this = this;
            $this.createSwiper();
            $(window).resize(this.debounce(function () {
                $this.createSwiper();
            }, 300));
        },
        messageTip: function (item, text) {
            let timer;
            clearTimeout(timer);
            $('body .size-message-tip').remove();
            $('body').append(`<div class='size-message-tip'>${text}</div>`);
            timer = setTimeout(function() {
                $('body .size-message-tip').remove();
            }, 3000);
            const message = $(item).find('.asSwatch-select-pc');
            message.text(text);
        },
        scrollOptions: function () {
            if ($(window).width() > 766) return;
            if (document.querySelector('.ProductContent-wrapper')) {
                // const rect = document.querySelector('.ProductContent-wrapper').getBoundingClientRect();
                // if (rect.top > 0) return;
                // const scrollTop = $('.ProductContent-wrapper').offset().top - 160;
                // $("html, body").animate({ scrollTop }, 300);
                $("html, body").animate({ scrollTop: 0 }, 300);
            }
            
        },
        selectOptionTip: function () {
            const options = [], items = $(`${this.selectors.ProductForm} .asProduct-swatch`);
            for (const item of items) {
                const option = item.dataset.option;
                if (!this.options[option]) {
                    const label = $(item).find('.asSwatch-lable').text()
                    this.messageTip(item, `Please Select ${label}`)
                    this.scrollOptions();
                    break;
                }
            }
        },
        addinToCart: function (att, qty, props) {
            $("body").addClass("loading");
            AjaxShop({
                url: `${window.Shopify.routes.root}cart/add.js`,
                data: {
                    id: att,
                    quantity: qty,
                    properties: props,
                    sections: ['cart-drawer', 'progress-bar', 'cart-items-num']
                }
            }).then((parsedState) => {
                if (parsedState.status) {
                    const { description } = parsedState;
                    $(".error-message").text(description);
                    $("body").addClass("showOverly");
                    $("#errorDrawer").fadeIn(500);
                    drawerTimeout = setTimeout(function(){
                        $("body").removeClass("showOverly");
                        $("#errorDrawer").fadeOut(200)
                    }, 4000);
                    return;
                }
                publish("cart-update", { parsedState });
                $(".block-cart").addClass("active");
            }).always(() => {
                $("body").removeClass("loading");
            })
        },
        productAddToCart: function () {
            const $this = this;
            // 判断JS加载完成 不用再阻止按钮
            window.ADD_FORM_SUBMIT_INIT = true;
            console.log('=====productAddToCart=========');
            $('form.asProductForm[action="/cart/add"]').on('submit', function(e){
                e.preventDefault();
                if ("disabled" != $(this).attr("disabled")) {
                    const att = $(this).find("input[name=id]").val();
                    const qty = $(this).find("input[name=quantity]").val() || 1;
                    // console.log($(this).find("input[name=quantity]").val(), qty);
                    const props = {};
                    const flow_from = $.cookie('flow_from');
                    $this.selectOptionTip();
                    if (flow_from) { props['flow_from'] = flow_from; };
                    if (!att) return;
                    $this.addinToCart(att, qty, props);
                }
            });
        },
        _getVariantFromOptions: function () {
            const variants = this.product.variants;
            const select_option = this.options;
            const found = variants.find((variant) => this._AhasBObj(variant, select_option));
            return found || {};
        },
        _updatePrice: function(variant) {
            $(this.selectors.originalPrice).html(theme.Currency.widthoutDecimals(variant.price));
            $(this.selectors.klarnaPrice).html(theme.Currency.widthoutDecimals(variant.price/4));
            const countPrice = $(this.selectors.countPrice);
            if (countPrice.length) {
                const count = countPrice.data('count');
                countPrice.html(theme.Currency.widthoutDecimals(variant.price/count));
            }
            if (variant.compare_at_price > variant.price) {
                $(this.selectors.comparePrice).removeClass('hide');
                $(this.selectors.comparePrice).html(theme.Currency.widthoutDecimals(variant.compare_at_price))
            } else {
                $(this.selectors.comparePrice).addClass('hide');
            }
        },
        _switchSliderImage: function(value) {
            const variants = this.product.variants;
            const select_option = Object.keys(this.options).filter((option) => this.options[option]);
            const imgVariant = variants.filter((variant) => select_option.every((option) => (this.options[option] == variant[option])));
            const colorImgVariant = variants.filter((variant) => variant.options.includes(value));
            const _imgVariant = imgVariant[0] || colorImgVariant[0] || variants[0];
            if (!_imgVariant.featured_media) return;
            const id = _imgVariant.featured_media.id;
            const imgItem = $(`${this.selectors.ProductImageItems} .ProductImage-item[data-id=${id}]`);
            if (!imgItem.length) return;
            const index = imgItem.data('index');
            if ($(window).width() > 766) {
                $(this.selectors.ProductImageItems).slick('slickGoTo', index);
            } else {
                const { left } = imgItem.offset();
                const itemsLeft = $('.ProductImage-items').scrollLeft() || 0;
                $('.ProductImage-items').animate({
                    scrollLeft: itemsLeft + left
                });
                // $('.ProductImage-items').animate({
                //     scrollLeft: left
                // });
            }
        },
        // 点击色值是切换url
        _updateGroupColorsHistoryState: function (color) {
            if (this.asIdToHandle.length > 0) {
                const variants = this.product.variants;
                const select_option = Object.keys(this.options).filter((option) => this.options[option]);
                const _variant = variants.filter((variant) => select_option.every((option) => (this.options[option] == variant[option])));
                /**
                 * <=0 不存在的sku 拼接handle 若上一个选择带有variant, 去除 variant
                 * ==1选中sku 进行色值切换 拼接handle ? variant = id
                 * > 1 未选中sku 进行色值切换 直接拼接handle
                 */
                const variant = _variant.length <= 0 ? variants.find((v) => v.options.indexOf(color) > -1) : _variant[0];
                const currentHandle = location.href.split(/products\/|\?/)[1];
                const selectProduct = this.asIdToHandle.find((item) => (item.vIds || '').split(',').includes(`${variant?.id}`));
                /**
                 * 颜色组合
                 * 点击其他商品 刷新 quickship 
                 * 更新 title/subtitle/模特首图描述
                 */
                if (selectProduct && selectProduct.id) {
                    const { title, subtitle, modelDesc } = selectProduct;
                    // console.log('selectProduct', selectProduct);
                    $('.as-product-title').text(title);
                    subtitle ? $('.product-subtitle').text(subtitle).show() : $('.product-subtitle').hide();
                    modelDesc ? $('.asProduct-size-desc').text(modelDesc).show() : $('.asProduct-size-desc').hide();
                }
                if (selectProduct && selectProduct.handle) {
                    if (selectProduct.handle === currentHandle) return
                    const v = _variant.length == 1 ? `?variant=${variant.id}` : '';
                    const newurl = `${window.location.origin}/products/${selectProduct.handle}${v}`;
                    window.history.replaceState({path: newurl}, '', newurl);
                    
                    if (selectProduct.id) {
                        $('#product_id').value = selectProduct.id;
                        this._productQuickShipPolicy();
                        CustomAnalysis && CustomAnalysis.awsCollection.productGroupColor({
                            product_id: selectProduct.id,
                            handle: selectProduct.handle,
                            color
                        });
                    }
                }
            }
        },
        _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
                return;
            }
            
            if (!variant.id) return;
            const search_variant = (location.href.split(/\&|\?/).find((t) => t.indexOf('variant=') > -1) || '').split('variant=').find((t) => t);
            if (variant.id == search_variant) return;
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({path: newurl}, '', newurl);
        },
        _updateAddToCartBtn: function (variant) {
            if (!variant.available) {
                $(this.selectors.addToCart).prop('disabled', true);
                $(this.selectors.addToCartText).text(theme.strings.soldOut);
                return;
            }
            const quantity = $(`.as-product-variant-inventory .apvi-${variant.id}`).data('variant-num');
            $(this.selectors.addToCart).prop('disabled', false);
            $(this.selectors.addToCartText).text(quantity < 1 ? theme.strings.preOrder : theme.strings.addToCart);
        },
        swatchSelectChange: function () {
            const $this = this;
            $(this.selectors.ProductForm).on('click', '.asProduct-swatch .ast-option', function() {
                const item = $(this).parents('.asProduct-swatch'),
                      title = item.find('.asProduct-swatch-title'),
                      value = $(this).data('value');
                const text = $(this).data('labelText');
                const label = title.find('.asSwatch-lable').text().toLocaleLowerCase(),
                      select_option = item.data('option');
                $(this).addClass('active').siblings().removeClass('active');
                // title.find('.asSwatch-value').text(value);
                const _value = label == 'size' ? text : value;
                title.find('.asSwatch-value').text(_value);
                title.find('.asSwatch-select-pc').text('');
                // if ($this.options[`${select_option}`] == value) return; 
                $this.options[`${select_option}`] = `${value}`;
                const color_options = 'color,colour,couleur,farbe,색상'.split(',');
                const size_options = 'size,rozmiar,talla,taille,tamaño,größe,크기'.split(',');
                if (color_options.includes(label)) {
                    $this._switchSliderImage(value);
                    $this._updateGroupColorsHistoryState(value);
                }
                if (size_options.includes(label)) {
                    $this.clickSizeShowBody(value);
                }
                // if (label == 'color') {
                //     $this._switchSliderImage(value);
                //     $this._updateGroupColorsHistoryState(value);
                // }
                // if (label == 'size') {
                //     $this.clickSizeShowBody(value);
                // }
                $this._skuChangeAddSoldOut($(this));
                const selectVariant = $this._getVariantFromOptions();
                if (Object.values($this.options).filter(o => o).length == $this.product.options.length) {
                    $this._updateAddToCartBtn(selectVariant);
                    if (!selectVariant.id) return; 
                    $($this.selectors.SelectId).val(selectVariant.id);
                    $this._updatePrice(selectVariant);
                    $this._updateHistoryState(selectVariant);
                    $this._productQuickShipPolicy(true);
                }
            });
        },
        swatchHover: function () {
            let tooltip = null;
            $('.ast-color').hover(function (evt) {
                if (tooltip) { tooltip.remove(); }
                const ct = $(evt.currentTarget);
                tooltip = ct.find('.ast-option-text').clone();
                const { left, top }= ct.offset();
                const wTop = $(document).scrollTop();
                tooltip.css({
                    opacity: 1,
                    visibility: 'visible',
                    position: 'fixed',
                    left: left + 19,
                    top: top - wTop - 19,
                    bottom: 'auto',
                });
                $('body').append(tooltip);
            }, function (evt) {
                tooltip && tooltip.remove();
            });
        },
        _AhasB: function (A, B) {
            return B.every(v => A.includes(v));
        },
        getOherOption: function (t) {
            if(tfxProduct.options.length <= 1) return [];
            const otherOption = Object.keys(this.options).splice(0, tfxProduct.options.length).find((p) => !t.includes(this.options[p]));
            const index = otherOption.replace('option', '') - 1;
            const op = this.product.variants.map((variant) => variant.options[index]);
            return [...new Set(op)];
        },
        _threeSkuChange: function (l, n) {
            if (l <= 1 || l > 3) return;
            let v = [];
            l == 2 && (v = [n]);
            l == 3 && (v=[[n[0], n[1]], [n[0], n[2]], [n[1], n[2]]]);
            if (!v.length) return;
            const $this = this, vs = this.product.variants;
            v.forEach(function (t) {
                const fvs = vs.filter(v => $this._AhasB(v.options, t));
                const otherOption = $this.getOherOption(t);
                const activeOption = [];
                fvs.forEach(function (fv) {
                    const b = $this.skuValid[fv.id] > 0;
                    const d = fv.options.filter(_fv => !t.includes(_fv))[0];
                    b && activeOption.push(d)
                });
                otherOption.forEach((d) => {
                    let _d = d;
                    if (_d.indexOf("'") > -1) { _d = _d.replaceAll(/\'/g, "\\'"); };
                    const k = $(`${$this.selectors.ProductForm} .ast-option[data-value='${_d}']`);
                    activeOption.includes(d) ? k.removeClass('soldout') : k.addClass('soldout');
                });
            });
        },
        _skuChangeAddSoldOut: function (e) {
            const $this = this,
                    d = $(e).data('value'),
                    vs = this.product.variants;
            let op = [];
            const fvs = vs.filter(v => v.options.includes(`${d}`));
            fvs.forEach(function (v) {
                op = op.concat(v.options);
            });
            op = [...new Set(op)].filter(v => (v!= d));
            const activeOption = [];
            const otherOption = $this.getOherOption([d]);
            op.forEach(function (v) {
                const b = fvs.filter(fv => fv.options.includes(v)).some(fv => ($this.skuValid[fv.id] > 0));
                b && activeOption.push(v);
            });
            otherOption.forEach((other) => {
                let _other = other;
                if (_other.indexOf("'") > -1) { _other = _other.replaceAll(/\'/g, "\\'"); };
                const k = $(`${$this.selectors.ProductForm} .ast-option[data-value='${_other}']`);
                activeOption.includes(other) ? k.removeClass('soldout') : k.addClass('soldout');
            });
            if (this.product.options.length === 3) {
                const itemActive = $(`${$this.selectors.ProductForm} .ast-option.active`),
                      itemActiveName = [];
                const l = itemActive.length;
                for (const r of itemActive) {
                    const _r = $(r).data('value');
                    itemActiveName.push(`${_r}`);
                }
                this._threeSkuChange(l, itemActiveName)
            }
        },
        _initSoldOutSku: function (d) {
            const $this = this;
            const vs = this.product.variants;
            const n = d.dataset.value;
            const fvs = vs.filter(v => v.options.includes(n));
            const b = fvs.some(fv => ($this.skuValid[fv.id] > 0));
            b ? $(d).removeClass('soldout') : $(d).addClass('soldout');
        },
        _initSkuRadio: function () {
            const swatchOptions = $(`${this.selectors.ProductForm} .ast-option`), inventorySpan = $('.as-product-variant-inventory span');
            for (const i of inventorySpan) {
                this.skuValid[i.dataset.variantId] = i.dataset.variantNum;
            }
            for (const d of swatchOptions) {
                this._initSoldOutSku(d)
            }
        },
        _initOptions: function () {
            if (location.href.indexOf('variant=') > -1) {
                const astActive = $(`${this.selectors.ProductForm} .ast-option.active `);
                for (const n of astActive) {
                    const option = $(n).parents('.asProduct-swatch').data('option');
                    const value = $(n).data('value');
                    this.options[`${option}`] = `${value}`;
                    setTimeout(function () {
                        $(n).trigger('click');
                    });
                }
            } else {
                // const astItems = $(`${this.selectors.ProductForm} .asProduct-swatch`);
                // for (const n of astItems) {
                //     const items = $(n).find('.ast-option');
                //     if (items.length == 1) {
                //         const option = $(n).data('option');
                //         const value = items.data('value');
                //         this.options[`${option}`] = `${value}`;
                //         setTimeout(function () {
                //             items.trigger('click');
                //         });
                //     }
                // }
            }
        },
        _productTabs: function () {
            const $this = this;
            $($this.selectors.ProductTab).on('click', '.apt-tab', function () {
                const index = $(this).index();
                if ($(this).hasClass('active')) return;
                $(this).addClass('active').siblings().removeClass('active');
                $(this).parents($this.selectors.ProductTab).find('.apt-content').eq(index).removeClass('hide').siblings().addClass('hide');
            });
        },
        _productDescribe: function () {
            $(this.selectors.ProductDescribe).on('click', '.product-describe-title', function () {
                const $ad = $(this).children('i.ad');
                $ad.hasClass('ad-angle-up-r') ? $ad.addClass('ad-angle-down-r').removeClass('ad-angle-up-r') : $ad.addClass('ad-angle-up-r').removeClass('ad-angle-down-r');
                $(this).next('div').slideToggle();
            });
        },
        _btnStickyBottom: function () {
            const ahaAddToCartBtn = document.querySelector('.asProduct-submit-wrapper');
            if (ahaAddToCartBtn) {
                new IntersectionObserver(function(op){
                    op[0].isIntersecting ? ahaAddToCartBtn.classList.remove('sticky-bottom') : ahaAddToCartBtn.classList.add('sticky-bottom');
                }, {
                    threshold: [0],
                    delay: 0,
                    rootMargin: '-88px 0px 0px 0px'
                }).observe(ahaAddToCartBtn);
            }
        },
        _upadteWuickShip: function (status) {
            status ? $('.detail-policy-list3').show() : $('.detail-policy-list3').hide();
        },
        getIpKey: function(key) {
            const ipParams = JSON.parse($.cookie('as_shopify_ip_address') || '{}');
            return ipParams[key] || '';
        },
        _productQuickShipPolicy: function (isClick) {
            const $this = this, skuId = $(`${this.selectors.SelectId}`).val();
            if (skuId) {
                if ($this.skuQuickLock) return;
                $this.skuQuickLock = true;
                AjaxApi('/web/product/sku/shipping/getList', {
                    skuId,
                    regionName: $this.getIpKey('regionName')
                }, "POST").then((res) => {
                    const skuFlag = res.entry ? res.entry.skuFlag : false;
                    $this.skuQuickLock = false;
                    $this._upadteWuickShip(skuFlag);
                });

                return;
            }
            if (isClick) return;
            AjaxApi('/web/product/spu/shipping/getList', {
                spuIds: [$('#product_id').val()],
                regionName: $this.getIpKey('regionName')
            }, "POST").then((res) => {
                const spuFlag = res.entry && res.entry[0] ? res.entry[0].spuFlag : false;
                $this._upadteWuickShip(spuFlag);
            });
        },
        _initSizeText: function () {
            const size_type = $('#product_size').val();
            const optionSizes = $(`${this.selectors.ProductForm} .ast-size .ast-option-label`);
            const sNode = [...optionSizes].map(function (t) { return t.innerHTML; });
            if (sNode.some(function (t) { return t.indexOf('(') > -1 || t.indexOf('（') > -1 })) return;
            let product_type = '';
            if ((size_type.indexOf('Z1') == 0) && this.tfxProductSizes[size_type]) {
                product_type = size_type;
            } else {
                for (var t in this.tfxProductSizes) {
                    if (size_type.indexOf(t) == 0) {
                        if (t.length > product_type.length) {
                            product_type = t;
                        }
                    }
                };
            }
            for (var n of optionSizes) {
                const v = n.innerHTML.replace(/\s*/g,'').toLocaleUpperCase();
                const sizes = this.tfxProductSizes[product_type] ? (this.tfxProductSizes[product_type][v] || {}) : {};
                const size_t = sizes['US'];
                if (size_t) {
                    n.innerHTML = n.innerHTML + `(${size_t})`;
                }
            }
        },
        _relatedSizeContent: function (value) {
            const size_type = $('#product_size').val();
            let v = `${value}`.replace(/\s*/g,'').toLocaleUpperCase();
            let product_type = '';
            if ((size_type.indexOf('Z1') == 0) && tfxProductSizes[size_type]) {
                product_type = size_type;
            } else {
                for (const t in tfxProductSizes) {
                    if (size_type.indexOf(t) == 0) {
                        if (t.length > product_type.length) {
                            product_type = t;
                        }
                    }
                };
            }
            if (product_type !== 'P1') {
                // 去除空格别以左括号分割
                v = v.split(/\(|\（/)[0];
            }
            if (v) {
                const sizes = tfxProductSizes[product_type] ? (tfxProductSizes[product_type][v] || {}) : {};
                let sizeHtml = '';
                for (let size in sizes) {
                    sizeHtml = sizeHtml + `<li>${size}: ${sizes[size]}</li>`;
                }
                $('.asProduct-size-content ul').html(sizeHtml);
                sizeHtml ? $('.asProduct-size-content').show() : $('.asProduct-size-content').hide()
            }
        },
        formatData: function (items) {
            const titleEnum = { "Sleeve": "Sleeves", "LegOpening": "Leg opening" };
            const keys = ['size', ...this.sizeToUp, ...this.sizeInitialToUp];
            const nkeys = keys.filter((key) => items.some((item) => item[key]));
            const _nkeys = nkeys.map((key) => {
                const title = this.firstToUpperCase(key);
                const list = items.map((item) => item[key]);
                return {
                    key,
                    title: titleEnum[title] || title,
                    list
                };
            });
            return _nkeys.filter((item) => (item.list.length > 0 && item.list.some((l) => Number(l) !== 0)));
        },
        formatSizeData: function () {
            const asSizeChart =  JSON.parse(JSON.stringify(this.sizeData));
            if (asSizeChart.bodyMeasurementListIN && asSizeChart.bodyMeasurementListIN.length > 0) {
                asSizeChart.bodyMeasurementListIN = this.formatData(asSizeChart.bodyMeasurementListIN);
                asSizeChart.bodyMeasurementListCM = this.formatData(asSizeChart.bodyMeasurementListCM);
            }
            if (asSizeChart.productMeasurementIn && asSizeChart.productMeasurementIn.length > 0) {
                asSizeChart.productMeasurementIn = asSizeChart.productMeasurementIn.map((item) => ({
                    ...item,
                    measurementItemDtoList: this.formatData(item.measurementItemDtoList)
                }));
                asSizeChart.productMeasurementCm = asSizeChart.productMeasurementCm.map((item) => ({
                    ...item,
                    measurementItemDtoList: this.formatData(item.measurementItemDtoList)
                }))
                // asSizeChart.productMeasurementIn = this.formatData(asSizeChart.productMeasurementIn);
                // asSizeChart.productMeasurementCm = this.formatData(asSizeChart.productMeasurementCm);
            }
            this.sizeTableData = asSizeChart;
        },
        createList: function (data, key) {
            let htmlStr = "";
            for (const item of data) {
                htmlStr = htmlStr +  `<li class="apsc-ctp-list apsc-ctpl-${item.key}"><div class="apsc-ctpl-item apsc-ctpl-title">${item.title}</div>`;
                for (const list of item.list) {
                    htmlStr = htmlStr + `<div class="apsc-ctpl-item apsc-ctpl-content">${list}</div>`
                }
                htmlStr = htmlStr + "</li>";
            }
            return htmlStr;
        },
        createTable: function (key) {
            const { bodyMeasurementListIN, bodyMeasurementListCM, productMeasurementIn, productMeasurementCm } = this.sizeTableData;
            if (key === 'product') {
                // console.log(productMeasurementIn, productMeasurementCm);
                // $('.apsc-ctp-in').html(this.createList(productMeasurementListIN));
                // $('.apsc-ctp-cm').html(this.createList(productMeasurementListCM));
            }
            if (key === 'body') {
                $('.apsc-ctb-in').html(this.createList(bodyMeasurementListIN));
                $('.apsc-ctb-cm').html(this.createList(bodyMeasurementListCM));
            }
        },
        createProduct: function () {
            const { productMeasurementIn, productMeasurementCm } = this.sizeTableData;
            let tabStr = "", productStr = "";
            let names = productMeasurementIn.map((item) => item.name).filter((name) => name);
            for (const name of names) {
                tabStr = tabStr + `<div class="apsc-content-product-tab" data-name="${name}">${this.firstToUpperCase(name)}</div>`;
            }
            for (const item of productMeasurementIn) {
                productStr = productStr + `<div class="apsc-cpc-content apsc-cp-content-in apsc-cp-content-in-${item.name || ''}">
                    <ul class="apsc-ctp-lists">${this.createList(item.measurementItemDtoList)}</ul>
                    <div class="apsc-content-desc">*This data was obtained from manually measuring the product, it may be off by 1-2 CM.</div>
                    ${item.markImage ? `<div class="apsc-content-img"><img src="${item.markImage}" /></div>` : ''}
                </div>`
            }
            for (const item of productMeasurementCm) {
                productStr = productStr + `<div class="apsc-cpc-content apsc-cp-content-cm apsc-cp-content-cm-${item.name || ''}">
                    <ul class="apsc-ctp-lists">${this.createList(item.measurementItemDtoList)}</ul>
                    <div class="apsc-content-desc">*This data was obtained from manually measuring the product, it may be off by 1-2 CM.</div>
                    ${item.markImage ? `<div class="apsc-content-img"><img src="${item.markImage}" /></div>` : ''}
                </div>`
            }
            $('.apsc-content-product-tabs').html(tabStr);
            $('.apsc-cp-content').html(productStr);
            $('.apsc-cp-content .apsc-cpc-content').eq(0).show();
            if ($('.apsc-content-product-tabs .apsc-content-product-tab').length > 0) {
                $('.apsc-content-product-tabs .apsc-content-product-tab').eq(0).trigger('click');
            }
        },
        showTables: function () {
            const { bodyMeasurementListIN, productMeasurementIn } = this.sizeData;
            if (bodyMeasurementListIN && bodyMeasurementListIN.length > 0) {
                this.createTable('body');
            } else {
                $('.apsc-content-tab[data-value="apsc-content-table-body"],.apsc-content-table-body').remove();
            }
            if (productMeasurementIn && productMeasurementIn.length > 0) {
                // this.createTable('product');
                this.createProduct();
            } else {
                $('.apsc-content-tab[data-value="apsc-content-table-product"],.apsc-content-table-product').remove();
            }
            if ($('.apsc-content-tab[data-value="apsc-content-table-body"] span').length > 0) {
                $('.apsc-content-tab[data-value="apsc-content-table-body"] span').eq(0).trigger('click');
            } else if ($('.apsc-content-tab span').length > 0) {
                $('.apsc-content-tab span').eq(0).trigger('click');
            }
        },
        // 等比例缩放图片
        createWeightHeihgt: function(list, type) {
            const $width = $(window).width(), l = list.length - 1;
            if (!l)  return '';
            let _scale = Math.pow(30/18, 1/l);
            let _width = 18, _height = 60;
            if ($width > 766) {
                _scale = Math.pow(42/28, 1/l);
                _width = 28, _height = 90;
            }
            let htmlStr = "";
            list.forEach((item, index) => {
                const c_scale = Math.pow(_scale, index);
                htmlStr = htmlStr + `<li class="apsc-content-wh-item">
                    <div class="acwi-inner">
                        <div class="acwn-wrapper acw-line">
                            <div class="apsc-content-wh-num">${item.size}</div>
                        </div>
                        <div class="acwt-wrapper acw-line">
                            <div class="apsc-content-wh-text1">weight</div>
                            <div class="apsc-content-wh-text2">${item.suggestWeight}${type == 'in' ? 'LB' : 'KG'}</div>
                        </div>
                        <div class="acwt-wrapper acw-line">
                            <div class="apsc-content-wh-text1">height</div>
                            <div class="apsc-content-wh-text2">${item.suggestHeight}${type == 'in' ? '' : 'CM'}</div>
                        </div>
                        <div class="acwi-wrapper">
                            <div class="apsc-content-wh-img" style="width: ${_width * c_scale}px;height: ${_height * c_scale}px;"></div>
                        </div>
                    </div>
                </li>`
            })
            return htmlStr;
        },
        sizeWeightHeihgt: function () {
            const { bodyMeasurementListIN, bodyMeasurementListCM } = this.bodyWeightHeight;
            if (bodyMeasurementListIN && bodyMeasurementListIN.length > 0) {
                $('.apsc-content-wh-in').html(this.createWeightHeihgt(bodyMeasurementListIN, 'in'));
                $('.apsc-content-wh-cm').html(this.createWeightHeihgt(bodyMeasurementListCM, 'cm'));
                // $('.pdc-in').html(this.createWeightHeihgt(bodyMeasurementListIN)).css({ display: 'flex' });
            }
        },
        detailWeightHeight: function () {
            const { bodyMeasurementListIN } = this.bodyWeightHeight;
            if (bodyMeasurementListIN && bodyMeasurementListIN.length > 0) {
                $('.pdc-in').html(this.createWeightHeihgt(bodyMeasurementListIN, 'in')).css({ display: 'flex' });
                $('.pdc-in').after('<div class="pdc-size-desc">*Depending on your body type and dressing habits, the aboove sizes are for reference only.</div>');
            }
        },
        descWithImg: function () {
            const { bodyMarkImage, productMarkImage } = this.sizeData;
            // if (productMarkImage) {
            //     $('.apsc-content-table-product .apsc-content-img').html(`<img src="${productMarkImage}" />`);
            // }
            if (bodyMarkImage) {
                $('.apsc-content-table-body .apsc-content-img').html(`<img src="${bodyMarkImage}" />`);
            }
        },
        // size全为数字时 赢藏body/product的US UK EU
        hideUsUkEu: function () {
            const sizeText = $('.apsc-content-table-product .apsc-ctpl-size .apsc-ctpl-content').map((i, n) => n.innerText);
            if (sizeText.length) {
                const isAllNumber = [...sizeText].every((s) => Number(s) > 0);
                if (isAllNumber) {
                    $('.apsc-switch-size,.apsc-ctpl-us,.apsc-ctpl-uk,.apsc-ctpl-eu').hide();
                }
            }
        },
        changeProducTable: function () {
            const product_tab_name = $('.apsc-content-product-tab.active').data('name') || '';
            const size_option_value = $('.apsc-switch-spec span.active').data('value') || '';
            $(`.apsc-cp-content-${size_option_value}-${product_tab_name}`).show().siblings('.apsc-cpc-content').hide();
        },
        initSizeChartEvent: function () {
            const sizeChartPopup = $(`${this.selectors.commonPopup}`);
            const $this = this;
            // 点击size下拉选择框 start 
            sizeChartPopup.on('click', '.apsc-switch-size-text', function () {
                $(this).next('ul').slideToggle(150, 'linear');
            });
            sizeChartPopup.on('click', '.apsc-switch-list', function () {
                $(this).parents('ul').slideToggle(150, 'linear');
                const value = $(this).data('value'), text = $(this).text();
                $(this).parents('.apsc-switch-size').find('.apsc-switch-size-value').text(text);
                const ske = $this.sizeToUp.map((k) => `.apsc-ctpl-${k}`).join();
                $(ske).hide();
                $(`.apsc-ctpl-${value}`).show();
            });
            // 点击size下拉选择框 end

            // IN or CM 的选择
            sizeChartPopup.on('click', '.apsc-switch-spec span', function () {
                if ($(this).hasClass('active')) return;
                const value = $(this).data('value');
                $(this).addClass('active').siblings().removeClass('active');
                const classStr = value === 'in' ? `.apsc-ctp-cm,.apsc-ctb-cm` : `.apsc-ctp-in,.apsc-ctb-in`;
                $(classStr).removeClass('active').siblings('.apsc-ctp-lists').addClass('active');
                $('.apsc-content-wh').removeClass('active');
                value === 'in' ? $('.apsc-content-wh-in').addClass('active') : $('.apsc-content-wh-cm').addClass('active');
                $this.changeProducTable();
            });

            // 多语言默认选中CM
            if ($this.languages.includes($this.language_local)) {
                const cmDom = $(`.apsc-switch-spec span[data-value="cm"]`);
                setTimeout(() => { cmDom.trigger('click'); });
            }
            
            // body or product 切换 .apsc-content-tab > span
            sizeChartPopup.on('click', '.apsc-content-tab span', function () {
                const p = $(this).parents('.apsc-content-tab');
                const selectContent = p.data('value');
                if (p.hasClass('active')) return;
                p.addClass('active').siblings().removeClass('active');
                $(`.${selectContent}`).show().siblings().hide();
            });
            // Switch 固定在顶部
            const sizeSwitchWrapper = document.querySelector('.apsc-content-switch-wrapper');
            if (sizeSwitchWrapper) {
                new IntersectionObserver(function(op){
                    op[0].isIntersecting ? sizeSwitchWrapper.classList.remove('sticky-top') : sizeSwitchWrapper.classList.add('sticky-top');
                }, {
                    threshold: [0],
                    delay: 0,
                }).observe(sizeSwitchWrapper);
            }
            // 套装尺码 product tab 点击
            sizeChartPopup.on('click', '.apsc-content-product-tab', function () {
                if ($(this).hasClass('active')) return;
                $(this).addClass('active').siblings().removeClass('active');
                $this.changeProducTable();
            });
            this.showTables();
            this.sizeWeightHeihgt();
            this.descWithImg();
            this.hideUsUkEu();
        },
        firstToUpperCase: function (str) {
            return str.slice(0, 1).toLocaleUpperCase() + str.slice(1);
        },
        sizeAddNumber: function () {
            const { bodyMeasurementListIN, modelDesc } = this.sizeData;
            if (modelDesc) {
                $(`${this.selectors.ProductForm} .asProduct-size-desc`).text(modelDesc).show();
            }
            if (bodyMeasurementListIN && bodyMeasurementListIN.length > 0) {
                const optionSizes = $(`${this.selectors.ProductForm} .ast-size .ast-option-label`);
                if ([...optionSizes].some(function (option) {
                    const t = option.innerHTML;
                    return t.indexOf('(') > -1 || t.indexOf('（') > -1;
                })) return;
                for (var n of optionSizes) {
                    let v = n.innerHTML.replace(/\s*/g,'');
                    v = this.language_size[v] ? this.language_size[v] : v;
                    const findObject = bodyMeasurementListIN.find((p) => (p.size.toLocaleUpperCase() === v.toLocaleUpperCase())) || {};
                    if (findObject.us) {
                        const sizeParent = $(n).parents('.ast-size');
                        sizeParent.attr('data-label-text', `${n.innerHTML}(${findObject.us})`);
                        // n.innerHTML = n.innerHTML + `(${findObject.us})`;
                    }
                }
            } else {
                this._initSizeText();
            }
        },
        clickSizeShowBody: function (sizeValue) {
            const { bodyMeasurementListIN, bodyMeasurementListCM } = this.sizeData, $this = this;

            if (bodyMeasurementListIN && bodyMeasurementListIN.length > 0) {
                const _v = `${sizeValue}`.replace(/\s*/g,'');
                // 去除空格别以左括号分割
                let v = _v.split(/\(|\（/)[0];
                v = $this.language_size[v] || v;
                const findObjectIN = bodyMeasurementListIN.find((p) => (p.size.toLocaleUpperCase() === v.toLocaleUpperCase())) || {};
                const findObjectCM = bodyMeasurementListCM.find((p) => (p.size.toLocaleUpperCase() === v.toLocaleUpperCase())) || {};
                const localeBool = $this.languages.includes($this.language_local);
                const findObject = localeBool ? findObjectCM : findObjectIN;
                let sizeHtml = '';
                [...$this.sizeToUp].filter((k) => findObjectIN[k]).map((k) => {
                    const name = k.toLocaleUpperCase();
                    sizeHtml = sizeHtml + `<li>${name}: ${findObjectIN[k]}</li>`;
                });
                [...$this.sizeInitialToUp].filter((k) => findObject[k]).map((k) => {
                    const name = `${$this.firstToUpperCase(k)}(${localeBool ? 'CM' : 'IN'})`;
                    sizeHtml = sizeHtml + `<li>${name}: ${findObject[k]}</li>`;
                });
                $('.asProduct-size-content ul').html(sizeHtml);
                sizeHtml ? $('.asProduct-size-content').show() : $('.asProduct-size-content').hide();
                $this.showSizeDeviation(v);
            } else {
                this._relatedSizeContent(sizeValue);
            }
        },
        showSizeDeviation: function (v) {
            const { productMeasurementIn, sizeDeviation } = this.sizeData, $this = this;
            // 长度 > 1 是套装尺码
            if (productMeasurementIn && productMeasurementIn.length > 1) return;
            const deviation = { 1: 'large', 2: 'small', 3: 'long', 4: 'short' };
            const $deviation = $('.asProduct-size-content .asProduct-size-deviation');
            const { measurementItemDtoList = [] } = productMeasurementIn && productMeasurementIn.length == 1 ? productMeasurementIn[0] : {};
            if (measurementItemDtoList && measurementItemDtoList.length > 0) {
                const findObject = measurementItemDtoList.find((p) => (p.size.toLocaleUpperCase() === v.toLocaleUpperCase()));
                if (findObject) {
                    if (findObject.sizeDeviation > 0) {
                        $deviation.text(`*This size runs ${deviation[findObject.sizeDeviation]}`).show();
                        return;
                    }
                    if (sizeDeviation > 0) {
                        $deviation.text(`*This size runs ${deviation[sizeDeviation]}`).show();
                        return;
                    }
                }
                $deviation.hide();
            }
        },
        sizeChartJudge: function () {
            const { bodyMeasurementListIN, productMeasurementIn } = this.sizeData;
            if ((bodyMeasurementListIN && bodyMeasurementListIN.length > 0) || (productMeasurementIn && productMeasurementIn.length > 0)) {
            } else {
                // 不在size guide上 绑定事件
                $('.asProduct-size').removeClass('popup-pc popup-m');
                $(this.selectors.ProductForm).magnificPopup({
                    delegate: '.asProduct-size',
                    removalDelay: 300, 
                    callbacks: {
                        beforeOpen: function() {
                            $('.stickyHeader').addClass('popup');
                            this.st.mainClass = this.st.el.attr('data-effect');
                        },       
                        close:function(){ $('.stickyHeader').removeClass('popup'); }
                    },
                    midClick: true 
                });
            }
        },
        popupTypeComponent: function (type) {
            if (type == 'sizeChart') {
                const title = 'Size Guide';
                $('.apc-header .apc-title').text(title);
                $('.as-product-common-content .apc-content').html(this.sizeChartHtml);
                this.initSizeChartEvent();
            }
            if (type == 'klarna') {
                const title = 'Shop now, pay later';
                $('.apc-header').addClass('pc-tl');
                $('.apc-header .apc-title').text(title);
                $('.as-product-common-content .apc-content').html(this.klarnaHtml);
            }
        },
        initPopupShow: function () {
            this.sizeChartJudge();
            this.detailWeightHeight();
            const commonPopupAll = $(`${this.selectors.commonPopupAll}`),
                  commonPopup = $(`${this.selectors.commonPopup}`);
            const $this = this;
            //移动端监听后退操作
            const hashConfig = ['#sizeChart', '#klarna'];
            window.addEventListener('hashchange', function() {
                if (hashConfig.some((_hash => location.hash.indexOf(_hash) > -1))) {
                    commonPopupAll.addClass('active')
                    $('html, body').addClass('skuActive');
                } else {
                    commonPopupAll.removeClass('active');
                    $('html, body').removeClass('skuActive');
                    $('.as-product-common-content .apc-content').empty();
                }
            });
            /**
             * 若URL中有#sizeChart/#klarna 删除url中的#sizeChart/#klarna
             * url中有 variant 时 筛选页面会去除其它参数
             */
            if (location.href.indexOf('variant=') < 0 && hashConfig.some((_hash => location.hash.indexOf(_hash) > -1))) {
                const new_url = location.href.replace(/(#sizeChart)|(#klarna)/, '');
                window.history.replaceState({ path: new_url }, '', new_url);
            }
            // pc端点击
            $('.popup-pc').on('click', function() {
                const type = $(this).data('type');
                if (!type) return;
                $this.popupTypeComponent(type);
                commonPopupAll.addClass('active');
                $('html, body').addClass('skuActive');
            });
            //PC端点击关闭图标
            commonPopup.on('click', '.apc-close', function () {
                commonPopupAll.removeClass('active');
                $('html, body').removeClass('skuActive');
                $('.as-product-common-content .apc-content').empty();
            });
            // 移动端点击
            $('.popup-m').on('click', function() {
                const type = $(this).data('type');
                if (!type) return;
                $this.popupTypeComponent(type);
                window.location.href = location.href + (location.href.indexOf(`#${type}`) > -1 ? '' : `#${type}`);
            });
            //移动端点击返回图标
            commonPopup.on('click', '.apc-back', function () {
                window.history.back();
            });
        },
        // 滚动到指定位置
        observeTab: function () {
            const tabs = document.querySelector('.as-product-tab');
            if (tabs) {
                new IntersectionObserver(function (tab) {
                    tab[0].isIntersecting ? $('.product-detail-more').fadeIn() : $('.product-detail-more').fadeOut()
                }, {
                    threshold: [0],
                    delay: 0,
                }).observe(tabs);
            }
        },
        scrollDetail: function () {
            if ($(window).width() > 766) return;
            // this.observeTab();
            $('.pdm-inner').on('click', function () {
                if ($('.product-describe').length) {
                    const scrollTop = $('.product-describe').eq(0).offset().top - 98;
                    $("html, body").animate({ scrollTop }, 600);
                }
            });
        },
        initPlayVideo: function () {
            const videos = $('video.as-product-video');
            try {
                // 移动端火狐浏览器 当video controls = true时 滑动无效
                if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && $(window).width() <= 766) {
                    console.log('videos', videos);
                    videos.prop({ controls: false });
                }
            } catch (erro) { console.log(error); }
            for (const video of videos) {
                new IntersectionObserver(function (entrys) {
                    const entry = entrys[0];
                    if (entry.isIntersecting) {
                        $(entry.target).trigger('play');
                    } else {
                        $(entry.target).trigger('pause');
                    }
                }, {
                    threshold: 0.9
                }).observe(video);
            }
        },
        initThirdApp: function () {
            const appThird = document.querySelector('.app-assembly');
            if (appThird) {
                var observer = new MutationObserver(function (mutations) {
                    $('.cbb-frequently-bought-add-button').on('click', function() {
                        // 用来判断加购是 插件按钮触发的
                        window.AS_APP_THIRD_BOUGHT_TOGRTHER = true;
                        // 若加购触发失败,30s后自动重置参数
                        let timer;
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            window.AS_APP_THIRD_BOUGHT_TOGRTHER = false;
                        }, 1000 * 30);
                    });
                });
                observer.observe(appThird, { childList: true });
            }
        },
        JudgeMeHeader: function (list) {
            const header_icon = $(list).find('.jdgm-rev__icon').prop('outerHTML') || '';
            const header_star = $(list).find('.jdgm-rev__rating').prop('outerHTML') || '';
            const header_name = $(list).find('.jdgm-rev__author').prop('outerHTML') || '';
            const header_badge = $(list).find('.jdgm-rev__buyer-badge').prop('outerHTML') || '';
            const headerHtml = `
                <div class="dgm-row-as-header">
                    ${header_icon}
                    <div class="dgm-row-as-right">
                        ${header_star}
                        <div class="dgm-row-as-text">
                            ${header_badge}
                            ${header_name}
                        </div>
                    </div>
                </div>
            `;
            $(list).before(headerHtml);
            $(list).remove();
        },
        JudgeMeType: function (list) {
            const typeHtml = `
                <div class="dgm-row-as-type">${$(list).html()}</div>
            `;
            $(list).parents('.jdgm-rev__content').before(typeHtml);
            $(list).remove();
        },
        JudgeMeChange: function (judgeBody) {
            const list_header = $(judgeBody).find('.jdgm-rev__header');
            let list_type = $(judgeBody).find('.jdgm-rev__cf-ans--text-type');
            if (!list_type.length) {
                list_type = $(judgeBody).find('.jdgm-rev__custom-form')
            }
            for(const list of list_header) {
                this.JudgeMeHeader(list);
            }
            for(const list of list_type) {
                this.JudgeMeType(list);
            }
        },
        initJudgeMe: function () {
            const judgeBody = document.querySelector('.asproduct-judge-lists .jdgm-rev-widg__body');
            if (!judgeBody) return;
            this.JudgeMeChange(judgeBody);
            new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    this.JudgeMeChange(mutation.target);
                }
            }).observe(judgeBody, { childList: true });
        }
    });
    if (theme.template_name === 'product') {
        new NewProduct();
    }
})()
